
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/llengua-de-signes",
      function () {
        return require("private-next-pages/corporatiu/atencio/llengua-de-signes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/llengua-de-signes"])
      });
    }
  